<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card class="mx-auto" max-width="400" min-height="100">
          <v-form ref="form" class="d-flex align-center justify-center" min-height="250">
            <v-btn class="ma-14 main-btn success-green" text @click="stripeLink()"> Manage Stripe Account </v-btn>
          </v-form>
          <v-card-text>
            <v-alert v-if="error" type="error">
              {{ error }}
            </v-alert>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
/* eslint-disable no-debugger */

import API from '../../api';

export default {
  name: 'StripeAccount',

  data: () => ({
    //    tags: [],
    error: null,
    sent: false
  }),
  mounted() {
    document.title = 'Stripe Account';
  },
  created: async function () {
    let res = await API.post('stripe/account-status', {});
    if (res.errors && res.errors.length > 0) {
      this.error = res.errors[0].msg;
      return;
    }
    //this.loadData(this.appointmentUuid);
    //window.location.href = res.data.url;
  },
  methods: {
    stripeLink: async function () {
      let res = await API.post('stripe/create-account', {});
      alert(JSON.stringify(res));
      if (res.errors && res.errors.length > 0) {
        this.error = res.errors[0].msg;
        return;
      }
    }
  }
};
</script>
<style></style>
